<template>
  <div
    class="flex w-full flex-col items-start"
    :class="{ 'dynamic-label': isValid, 'my-3': !removeYMargin }"
  >
    <label
      class="w-full text-left text-2xs font-bold uppercase"
      :class="[
        isValid ? 'text-dark-blue' : 'text-red-500',
        { 'label-disabled': disabled },
        { 'label-error': error },
      ]"
      :for="calculateId"
    >
      {{ label }}
      <div
        :class="{ 'mt-1': label }"
        class="relative w-full"
      >
        <input
          :id="calculateId"
          ref="inputField"
          :class="[
            minimalStyle
              ? 'w-full border bg-steel-100 p-2 font-normal text-neutral-subtlest hover:bg-steel-200 focus:border-neutral-subtle-boldest focus:bg-white'
              : 'w-full border focus:bg-white focus:text-dark-gray',
            isValid ? 'bg-off-white' : `input-error bg-red-100 text-red-500`,
            { 'hover:border-placeholder-gray': !disabled },
            { error: error },
            { 'uppercase placeholder:normal-case': isState },
            customPadding ? 'customPadding' : 'input-padding',
            textClassComputed,
            customInputClass,
            borderClassComputed,
            borderRadiusClassComputed,
          ]"
          :value="value"
          :type="name.includes('email') ? 'email' : type"
          :placeholder="placeholder"
          :name="name"
          :disabled="disabled"
          :maxlength="maxlength || inputLength"
          :pattern="pattern === 'number' ? '[0-9]*' : undefined"
          :autofocus="autoFocus"
          @input="validatedInput"
          @change="emitInput"
          @blur="blurValidation"
        />
        <span v-if="searchIcon">
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="magnifying-glass glass-icon"
          >
            <path
              d="M12.0195 12.7188L16.4995 17.1987"
              stroke="#6D7181"
              stroke-width="2"
            />
            <circle
              cx="8.17989"
              cy="8.23897"
              r="6.67989"
              stroke="#6D7181"
              stroke-width="2"
            />
          </svg>
        </span>
        <span v-if="!isValid && showCheck">
          <img
            src="@/assets/red-exclimation.svg"
            alt=""
            class="absolute right-4 top-2"
          />
        </span>
      </div>
    </label>
    <span
      v-if="alertMessage"
      class="mt-2 text-2xs text-gray-500"
    >
      {{ alertMessage }}
    </span>
    <span
      v-if="!isValid && !name.includes('account_number')"
      class="mt-2 text-2xs text-red-500"
    >
      {{ errorMessage }}
    </span>
    <span
      v-if="!isValid && name.includes('account_number')"
      class="text-xm text-red-500"
      :class="name.includes('verify_account_number') ? 'mt-2' : ''"
    >
      {{ errorMessage }}
    </span>
    <p
      v-if="error"
      class="mt-1 text-left text-2xs text-light-red"
      aria-live="assertive"
    >
      {{ error }}
    </p>
  </div>
</template>
<script>
import { isEmail } from '@/common/validators';
import intlTelInput from 'intl-tel-input';

export default {
  name: 'FormField',
  props: {
    label: String,
    type: {
      default: 'text',
      type: String,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    placeholder: String,
    errorMessage: [String, Boolean],
    name: String,
    id: [String, Boolean],
    onInput: Function,
    onBlur: Function,
    preferredCountries: {
      type: Array,
      default() {
        return [];
      },
      required: false,
    },
    isValid: {
      default: true,
    },
    pattern: String,
    showCheck: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    emptyField: {
      type: Boolean,
      default: true,
    },
    autoFocus: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: [String, Number],
      default: '',
    },
    searchIcon: {
      type: Boolean,
      default: false,
    },
    field: {
      type: Object,
      required: false,
    },
    error: {
      type: String,
      default: '',
    },
    customPadding: {
      type: Boolean,
      default: false,
    },
    removeYMargin: {
      type: Boolean,
      default: false,
    },
    allowFullStateName: {
      type: Boolean,
      default: false,
    },
    alertMessage: {
      type: String,
      default: '',
      required: false,
    },
    minimalStyle: {
      type: Boolean,
      default: false,
    },
    customInputClass: {
      type: String,
      default: '',
    },
    customInputTextClass: {
      type: String,
      default: '',
    },
    initialCountry: {
      type: String,
      default: 'us',
    },
    isBorderRed: {
      type: Boolean,
      default: false,
    },
    borderRadiusClass: {
      type: String,
      default: '',
    },
  },
  // watch: {
  //   value: function (newVal) {
  //     if (newVal && this.type == "tel") {
  //       console.log(" ");
  //       console.log("FormField elementData");
  //       console.dir(this.elementData);
  //       console.log("Phone val");
  //       console.dir(this.elementData.getNumber());
  //       console.log("isValidNumber");
  //       console.log(this.elementData.isValidNumber());
  //       console.log("countryIso");
  //       console.log(this.elementData?.selectedCountryData?.iso2);
  //       console.log(" ");
  //     }
  //   },
  // },
  setup(props) {
    const validatedInput = (e) => {
      if (e.target.name.includes('email')) {
        const checkEmail = isEmail(e.target.value);
        if (checkEmail) {
          return props.onInput(e);
        }
      } else {
        return props.onInput(e);
      }
    };
    const blurValidation = (e) => {
      if (!props.onBlur) return;
      return props.onBlur(e);
    };
    const emitInput = (e) => {
      return props.onInput(e);
    };
    return {
      emitInput,
      validatedInput,
      blurValidation,
      ...props.field,
    };
  },
  data() {
    return {
      elementData: null,
      baseCountries: ['us', 'ca', 'mx'],
      // baseAndEuropeanCountries: ["us", "ca", "mx", "at", "by", "be", "bg", "hr", "cy", "cz", "dk", "ee", "fi", "fr", "de", "gr", "hu", "ie", "it", "lv", "lt", "lu", "mt", "md", "nl", "pl", "pt", "ro", "rs", "sk", "si", "es", "se", "ch", "ua", "gb"],
      // convert VAT country codes to ISO 3166-1 alpha-2 codes
      iso_correct: {
        el: 'gr',
      },
    };
  },
  computed: {
    defaultTextClass() {
      return this.minimalStyle ? 'text-sm' : 'text-1md';
    },
    textClassComputed() {
      return this.customInputTextClass || this.defaultTextClass;
    },
    defaultBorderRadiusClass() {
      return this.minimalStyle ? 'rounded-md' : 'rounded';
    },
    borderRadiusClassComputed() {
      return this.borderRadiusClass || this.defaultBorderRadiusClass;
    },
    borderClassComputed() {
      return this.isBorderRed
        ? 'border-red-500'
        : !this.isValid
          ? 'border-transparent'
          : this.minimalStyle
            ? 'border-steel-40'
            : 'border-transparent';
    },
    inputLength() {
      switch (true) {
        case this.name.includes('clabe'):
          return '18';
        case this.name.includes('phone_number') || this.name.includes('phone'):
          return '12';
        case this.name.includes('ssn'):
          return '11';
        case this.name.includes('ein'):
          return '10';
        case this.name.includes('state') && !this.allowFullStateName:
          return '2';
        case this.name.includes('routing_number'):
          return '9';
        case this.name.includes('account_number'):
          return '17';
        case this.name.includes('branch'):
          return '5';
        case this.name.includes('bank_eft'):
          return '3';
        case this.name.includes('account'):
          return '12';
        default:
          return '200';
      }
    },
    preferredCountry() {
      return this.$store.state.users.preferredCountry;
    },
    identifier() {
      return this.$store.state.carriers?.carrierDetails?.identifiers?.[0];
    },
    calculateId() {
      return this.id || this.label?.split(' ').join('_').toLowerCase();
    },
    isState() {
      return this.name.includes('state') && !this.allowFullStateName;
    },
  },
  mounted() {
    if (this.type === 'tel') {
      if (this.preferredCountries.length === 0) {
        this.elementData = intlTelInput(this.$refs?.inputField, {
          initialCountry: this.initialCountry,
          separateDialCode: true,
          countryOrder: [this.verifyPreferredCountry()],
          containerClass: 'w-full',
          nationalMode: true,
          formatAsYouType: false,
          loadUtils: () => import('intl-tel-input/utils'),
        });
      } else {
        this.elementData = intlTelInput(this.$refs?.inputField, {
          initialCountry: this.initialCountry,
          separateDialCode: true,
          onlyCountries: ['us', 'ca', 'mx'],
          countryOrder: [this.verifyPreferredCountry()],
          containerClass: 'w-full',
          nationalMode: true,
          formatAsYouType: false,
          loadUtils: () => import('intl-tel-input/utils'),
        });
      }
      this.$refs?.inputField.addEventListener('countrychange', (e) => {
        if (e.target.value) {
          this.validatedInput(e);
        }
      });
      this.$refs?.inputField.addEventListener(
        'countrychange',
        this.emitCountryChange
      );
    } else {
      this.elementData = this.$refs?.inputField;
    }
  },
  beforeUnmount() {
    // Destoy event listener
    if (this.type === 'tel') {
      this.$refs?.inputField.removeEventListener('countrychange', (e) => {
        this.validatedInput(e);
      });
    }
  },

  methods: {
    emitCountryChange() {
      const iso = this.elementData?.getSelectedCountryData()?.iso2;
      const dialCode = this.elementData?.getSelectedCountryData()?.dialCode;
      console.log('emitCountryChange - iso', iso);
      this.$emit('country-changed', { iso, dialCode });
    },
    verifyPreferredCountry() {
      if (this.identifier) {
        console.log('verifyPreferredCountry - identifier');
        console.dir(this.identifier);
        const type = this.identifier?.is_type;
        const isCanadian =
          type?.includes('NSC') ||
          type?.includes('NIR') ||
          type?.includes('CVOR');
        const isMexican = type?.includes('RFC');
        const isEuropean = type?.includes('VAT_');

        if (isCanadian) this.$store.commit('users/setPreferredCountry', 'ca');
        if (isMexican) this.$store.commit('users/setPreferredCountry', 'mx');
        if (isEuropean) {
          console.log('verifyPreferredCountry - isEuropean - type');
          console.dir(type);
          const iso = this.getLowercaseIsoCorrect(type);
          this.$store.commit('users/setPreferredCountry', iso);
        }
      }

      return this.preferredCountry;
    },
    getLowercaseIsoCorrect(type) {
      if (!type) return;
      console.log('getLowercaseIsoCorrect - type');
      console.log(type);
      // This assumes that the last 2 letters of the identifier_is_type are the ISO 3166-1 alpha-2 code for the country (or mapped within this.iso_correct)
      let abbv = type?.toLowerCase()?.slice(-2);
      if (!abbv) return;
      if (this.iso_correct?.[abbv]?.length > 0) {
        return this.iso_correct[abbv];
      }
      return abbv;
    },
    // Expose elementData for external access
    getElementData() {
      return this.elementData;
    },
  },
};
</script>
<style scoped>
.dynamic-label:focus-within > label {
  @apply text-dark-blue;
}

/* input:focus {
  outline-offset: 0;
} */

.input-error:-webkit-autofill,
.input-error:-webkit-autofill:hover,
.input-error:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0px 1000px white inset;
  -webkit-text-fill-color: #db3713;
  transition: background-color 5000s ease-in-out 0s;
}

input:disabled {
  @apply bg-off-white text-gray-over-dark !important;
}

.label-disabled {
  @apply text-gray-over-dark !important;
}

.label-error {
  @apply text-light-red !important;
}

.glass-icon {
  top: 50%;
  transform: translateY(-50%);
}

.input-padding {
  padding: 15px 24px;
}

.customPadding {
  padding: 10px 20px;
}

input.error {
  @apply border-red-500 !important;
  @apply bg-light-red bg-opacity-10 !important;
}
</style>
